const locale = {
	noNotifications: 'There are currently no notifications.',
	clearAll: 'clear all',
	open: 'Open',
	notifications: 'Notifications'
};
export default locale;
